<button mat-button style="height: 25px; padding: 0" (click)="setLanguage(viewData().language)">
	<div class="language-button-inner-container">
		<img class="flag-icon" [src]="viewData().flagUrl" alt="" />
		<div class="language">{{ viewData().language }}</div>
	</div>
</button>
